export default "/_next/static/chunks/fonts/proximanova-bold-webfont-f96e7968c1d663b95d0910ecc8b59d45.woff";